'use strict';

function SalaryOverviewController(salaryService, $window, $log, $location) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.useNewCode = useNewCode;
  vm.showInterview = showInterview;

  vm.performanceAssessment = {
    useNewPerformance: useNewPerformance,
    goToNewPerformance: goToNewPerformance,
    getNewPerformanceStateDisplay: getNewPerformanceStateDisplay,
    getPerformanceIcon: getPerformanceIcon,
    getPerformanceBtnClass: getPerformanceBtnClass,
  };

  function $onInit() {
  }

  function _getSalaryTokenUrl(service, token) {
    return service.urls.questionnaire.step({token: token, step: 'intro'});
  }

  function showInterview(inviteIndex) {
    var token = vm.invites[inviteIndex].token;
    var url = _getSalaryTokenUrl(salaryService, token);
    $location.path(url);
  }

  function useNewPerformance(invite) {

    if (!invite.performance_assessment) {
      return false;
    }
    return !!invite.performance_assessment.coworker_doc_url;
  }

  function goToNewPerformance(invite) {
    if (invite.performance_assessment) {
      var url = invite.performance_assessment.coworker_doc_url;
      $window.location.href = url;
    }
  }

  function getNewPerformanceStateDisplay(invite) {
    if (!invite.performance_assessment) {
      return 'Error';
    }
    return invite.performance_assessment.button_text;
  }

  function useNewCode(invite) {

    if (!invite.performance_assessment) {

      return false;
    }
    return !!invite.performance_assessment.coworker_doc_url;
  }

  function getPerformanceIcon(invite) {
    if (!invite.performance_assessment) {
      return 'fa fa-circle-exclamation';
    }
    if (invite.performance_assessment.state === 'performance_completed') {
      return 'fa fa-check';
    }
    return 'fa fa-briefcase';

  }

  function getPerformanceBtnClass(invite) {
    if (!invite.performance_assessment) {
      return 'btn btn-xs btn-new danger';
    }
    if (invite.performance_assessment.state === 'performance_completed') {
      return 'btn btn-xs btn-new primary';
    }
    return 'btn btn-xs btn-default';
  }


}

module.exports = SalaryOverviewController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-overview/salary-overview.controller.js
 ** module id = 244
 ** module chunks = 0
 **/